import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AcceptanceCriteria } from '../models/acceptance-criteria.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AcceptanceCriteriaService {
  private apiUrl = environment.apiUrl + environment.acceptanceCriteriaPath;

  constructor(private http: HttpClient) {}

  getAcceptanceCriteria(): Observable<AcceptanceCriteria[]> {
    return this.http.get<AcceptanceCriteria[]>(this.apiUrl);
  }

  createAcceptanceCriteria(criteria: AcceptanceCriteria): Observable<AcceptanceCriteria> {
    return this.http.post<AcceptanceCriteria>(this.apiUrl, criteria);
  }

  updateAcceptanceCriteria(criteria: AcceptanceCriteria): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${criteria.id}`, criteria);
  }

  getAcceptanceCriteriaById(id: number): Observable<AcceptanceCriteria> {
    return this.http.get<AcceptanceCriteria>(`${this.apiUrl}/${id}`);
  }

  disabledAcceptanceCriteria(criteria: AcceptanceCriteria): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}${environment.disabledPath}/${criteria.id}`, criteria);
  }

  deleteAcceptanceCriteria(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
